/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import { Rating } from "@mui/material";
import { FaUniversity } from "react-icons/fa";
import moment from "moment";
import { ReactSVG } from "react-svg";
import { getAssets, whatTimeAgo } from "@unisearch/helpers";
import styles from "./uni_review_card.module.scss";

export const UniReviewCard = ({ item }) => {
  //show less comment
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  //handle child item
  const [toggleIds, setToggleIds] = useState([]);
  const handleToggle = (id) => {
    if (!id) return false;

    if (toggleIds.includes(parseInt(id))) {
      let newItem = toggleIds.filter(
        (filteredId) => filteredId != parseInt(id)
      );
      setToggleIds(newItem);
    } else {
      setToggleIds((prev) => [...prev, parseInt(id)]);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.image_wrapper}>
        <img
          src={
            item?.profileImage
              ? item?.profileImage
              : getAssets("assets/uni_guest.png")
          }
          alt={item?.reviewerName}
        />
      </div>
      <div className={styles.info_wrapper}>
        {item?.reviewerName && (
          <div className={styles.name}>{item?.reviewerName.trim()}</div>
        )}

        <Rating name="read-only" value={parseInt(item?.rating)} readOnly />
        <div className={styles.time}>
          {moment(item?.reviewDateTime).format("DD MMMM YYYY")}
        </div>
        <div className={styles.content}>
          {isOpen ? item?.reviewComment : item?.reviewComment.slice(0, 200)}

          {item?.reviewComment?.length > 200 && (
            <span onClick={() => handleOpen()}>
              {isOpen ? (
                <span className={styles.showmore}>show less</span>
              ) : (
                <span className={styles.showmore}>...read more</span>
              )}
            </span>
          )}
        </div>

        {/* Reply  */}
        {item?.replies?.length > 0 &&
          item?.replies?.map((rpl, i) => {
            return (
              <div className={styles.review_reply_wrapepr} key={`reply${i}`}>
                <div className={styles.reply_avatar}>
                  {rpl?.university?.logo ? (
                    <img
                      src={
                        rpl?.university?.logo?.src ||
                        getAssets("assets/mentor-avatar-small.png")
                      }
                      alt="logo"
                    />
                  ) : (
                    <FaUniversity
                      style={{ fontSize: "35px", color: "#C3CAD9" }}
                    />
                  )}
                </div>
                <div className={styles.reply_detail}>
                  <div className={styles.reply_name_time}>
                    <span className={styles.reply_name}>
                      {rpl?.university?.universityName}
                    </span>
                    <span className={styles.reply_time}>
                      {whatTimeAgo(rpl?.createdAt)}
                    </span>
                  </div>
                  <div className={styles.repay_text}>
                    {toggleIds.includes(parseInt(rpl?.reviewReplyId))
                      ? rpl?.message
                      : rpl?.message?.slice(0, 200)}

                    {rpl?.message?.length > 200 && (
                      <span onClick={() => handleToggle(rpl?.reviewReplyId)}>
                        {toggleIds.includes(parseInt(rpl?.reviewReplyId)) ? (
                          <span className={styles.showmore}>show less</span>
                        ) : (
                          <span className={styles.showmore}>...read more</span>
                        )}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default UniReviewCard;
